import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";

const baseUrl = `${baseURL}/home-settings/`;

export const homeSettingsApiService = createApi({
  reducerPath: "homeSettingsApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getTrendingProducts: builder.query({
      query: () => "trending-products",
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    getSections: builder.query({
      query: () => "section",
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    getNewsletter: builder.query({
      query: () => "newsletter",
      refetchOnMountOrArgChange: true,
      keepUnusedDataFor: 0,
    }),
    subscribeToNewsletter: builder.mutation({
      query: ({ newsletter_id, email }) => ({
        url: `newsletter/${newsletter_id}/add-email`,
        method: "POST",
        body: { email },
      }),
    }),
  }),
});

export const {
  useGetTrendingProductsQuery,
  useGetSectionsQuery,
  useGetNewsletterQuery,
  useSubscribeToNewsletterMutation,
} = homeSettingsApiService;
